import {
  getColumnIndexName,
} from '../../../../components/gsheet';

function getCellInRow(table_header, header_name) {
  const column_index_name = getColumnIndexName(table_header, header_name);
  return `INDIRECT(CONCAT("${column_index_name}", ROW()))`;
}


// iferror(ifs(find(",",I2), "yes", find("+",I2), "no"), "no")
export default function getOrderUnknownCondition(
  table_header, column_name) {
  const column_cell_in_row = getCellInRow(table_header, column_name);

  const findComma = `FIND(",", ${column_cell_in_row})`;
  const findPlus = `FIND("+", ${column_cell_in_row})`;
  const caseAnalysis = `IFS(${findComma}, "Yes", ${findPlus}, "No")`;
  const ifError = `IFERROR(${caseAnalysis}, "No")`;

  return `=${ifError}`;
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/gtable/orderUnknown.js